import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import StepsPanelImg from '../../../../../common/assets/images/merchants/steps-panel.png';
import Icons from '../../../../../common/widgets/Icons';
import { config } from '../../../config';
import { AccountInfoContext } from '../../../contexts/AccountInfoContext';
import { resources } from '../../../resources/resources';

export function StepsPanelNewUser() {
  const { t: translate } = useTranslation();

  return (
    <div className="first-steps-panel">
      <div className="first-steps-content">
        <h3>{translate(resources.help.mainPanel.newUser.title)}</h3>
        <ul className="list-reset">
          <li>
            <div className="step-icon">
              <Icons.MHelpStepsCompany />
            </div>
            <div className="step-content">
              <Link to="/company-settings">
                {translate(resources.help.mainPanel.newUser.link1)}
              </Link>
              <span>{translate(resources.help.mainPanel.newUser.text1)}</span>
            </div>
          </li>
          <li>
            <div className="step-icon">
              <Icons.MHelpStepsProducts />
            </div>
            <div className="step-content">
              <Link to="/products/add">
                {translate(resources.help.mainPanel.newUser.link2)}
              </Link>
              <span>{translate(resources.help.mainPanel.newUser.text2)}</span>
            </div>
          </li>
          <li>
            <div className="step-icon">
              <Icons.MHelpStepsNew />
            </div>
            <div className="step-content">
              <Link to="/support">
                {translate(resources.help.mainPanel.newUser.link3)}
              </Link>
              <span>{translate(resources.help.mainPanel.newUser.text3)}</span>
            </div>
          </li>
        </ul>
      </div>
      <div className="first-steps-image">
        <img
          src={StepsPanelImg}
          alt={translate(resources.help.mainPanel.imageAlt)}
        />
      </div>
    </div>
  );
}

export function StepsPanelExistingUser() {
  const { t: translate } = useTranslation();
  const { accountInfo } = useContext(AccountInfoContext);

  return (
    <div className="first-steps-panel">
      <div className="first-steps-content">
        <h3>{translate(resources.help.mainPanel.existingUser.title)}</h3>
        <ul className="list-reset">
          <li>
            <div className="step-icon">
              <Icons.MHelpStepsProducts />
            </div>
            <div className="step-content">
              <Link to="/products/add">
                {translate(resources.help.mainPanel.existingUser.link1)}
              </Link>
              <span>
                {translate(resources.help.mainPanel.existingUser.text1)}
              </span>
            </div>
          </li>
          <li>
            <div className="step-icon">
              <Icons.MHelpStepsVouchers />
            </div>
            <div className="step-content">
              <Link to="/products/codes">
                {translate(resources.help.mainPanel.existingUser.link2)}
              </Link>
              <span>
                {translate(resources.help.mainPanel.existingUser.text2)}
              </span>
            </div>
          </li>
          {accountInfo.usesAnalytics ? (
            <>
              {config.showAnalytics && (
                <li>
                  <div className="step-icon">
                    <Icons.MHelpStepsAnalytics />
                  </div>
                  <div className="step-content">
                    <Link to="/analytics">
                      {translate(resources.help.mainPanel.existingUser.link3)}
                    </Link>
                    <span>
                      {translate(resources.help.mainPanel.existingUser.text3)}
                    </span>
                  </div>
                </li>
              )}
            </>
          ) : (
            <li>
              <div className="step-icon">
                <Icons.MHelpStepsAnalytics />
              </div>
              <div className="step-content">
                <Link to="/marketing">
                  {translate(resources.help.mainPanel.existingUser.link4)}
                </Link>
                <span>
                  {translate(resources.help.mainPanel.existingUser.text4)}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>
      <div className="first-steps-image">
        <img
          src={StepsPanelImg}
          alt={translate(resources.help.mainPanel.imageAlt)}
        />
      </div>
    </div>
  );
}
